const createButtonCompChecklist = {
  question: 'Criar Pergunta +'
};

export default createButtonCompChecklist;
